module.exports = __webpack_public_path__ + "static/media/beforemi.ce5a4090.gif";